//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Typography } from '@mui/material';
import { Pagination } from '@/redux/slices/slice_types';
import styled from '@emotion/styled';

type ResultsLabelProps = {
  results?: Pagination['total'];
  text: string;
};

const ResultsLabel = ({ results, text }: ResultsLabelProps) => (
  <ResultsText variant="h5">
    <Total>{results?.toLocaleString() || 0}</Total>
    {text}
  </ResultsText>
);

export default ResultsLabel;

const ResultsText = styled(Typography)`
  font-size: 1.3rem;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

const Total = styled.strong`
  padding-right: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.primary.main};
`;
